export default __webpack_public_path__ + "9df99d3f62eb109e036170f7f24cddda.jpg";